import React, { useState, useEffect } from "react";
import Loader from "../Loader";
import NoResult from "../NoResult";
import CustomizeTableview from "../TableViews/CustomizeTableview";
import PaginationBar from "../PaginationBar";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import useApi from "../../Hooks/useApi";
import * as api from "../../api/getapi";

const SellerOrders = ({ search, statusSearch, fromDate, toDate, sizeOfPages }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [noOfPages, setNoOfPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [toggle, refresh] = useState(false);
  const [orders, setOrders] = useState([]);
  const [totalOrders, setTotalOrders] = useState();
  const [orderBy, setOrderBy] = useState({ created_at: "DESC" });

  const fetchAllSellerOrders = useApi(api.fetchAllSellersOrders, { hasCatchError: true });

  const changePage = (page) => {
    setCurrentPage(page);
  };

  //searchParams
  useEffect(() => {
    if (searchParams.get("page")) {
      setCurrentPage(Number(searchParams.get("page")));
    }
  }, [currentPage, toggle, searchParams]);
  function getSellerPayments() {
    try {
      fetchAllSellerOrders
        .request({
          page: currentPage,
          size: sizeOfPages,
          status: statusSearch,
          search: search,
          fromDate: fromDate,
          toDate: toDate,
          orderBy: orderBy,
        })
        .then((data) => {
          setIsLoading(false);
          setTotalOrders(data?.data?.paginationData?.no_of_items);
          setOrders(data?.data?.paymentsData);

          if (data?.data?.paginationData?.no_of_pages === 0) {
            if (searchParams.get("page")) {
              setNoOfPages(0);
              navigate("/delivery-for-you/seller-payments?page=0");
            }
          } else {
            setNoOfPages(data?.data?.paginationData?.no_of_pages);
            if (currentPage > data?.data?.paginationData?.no_of_pages) {
              setCurrentPage(data?.data?.paginationData?.no_of_pages);
              navigate("/delivery-for-you/seller-payments?page=" + data?.data?.paginationData?.no_of_pages);
            }
            if (searchParams.get("page") === "0") {
              setCurrentPage(1);
              navigate("/delivery-for-you/seller-payments?page=1");
            }
          }
        })
        .catch((err) => {
          const tempErr = err.response.data.error;

          if (tempErr.status === 404 && tempErr.message === "No Record Found") {
            setOrders([]);
            setIsLoading(false);
          }
        });
    } catch (err) {
      const tempErr = err.response.data.error;

      if (tempErr.status === 404 && tempErr.message === "No Record Found") {
        setOrders([]);
        setIsLoading(false);
      }
    }
  }

  useEffect(() => {
    let timeout;
    setIsLoading(true);
    getSellerPayments();
    return () => {
      clearTimeout(timeout);
    };
  }, [search, fromDate, toDate, currentPage, noOfPages, sizeOfPages, statusSearch, toggle, orderBy]);
  useEffect(() => {
    if (currentPage === 1) {
      refresh((prev) => !prev);
    } else {
      changePage(1);
    }
  }, [fromDate, toDate, statusSearch]);
  return (
    <>
      {isLoading ? (
        <div
          style={{
            height: "50vh",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Loader />
        </div>
      ) : orders?.length === 0 ? (
        <NoResult />
      ) : (
        <>
          <CustomizeTableview
            data={orders}
            columnNotShow={["id", "is_deleted", "payment_proof", "payment_transaction_id", "is_paid"]}
            dateColumn={["created_at", "updated_at", "paid_at", "processed_at"]}
            sortColumn={["created_at", "updated_at", "paid_at"]}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            status={{
              column: ["expiry_date"],
              getClassName: ({ payment_status }) => {
                if (payment_status === "Pending") {
                  return "text-warning";
                } else if (payment_status === "Settled") {
                  return "text-success";
                } else {
                  return "text-danger";
                }
              },
              format: ({ payment_status }) => {
                if (payment_status === "Pending") {
                  return "Pending";
                } else if (payment_status === "Settled") {
                  return "Settled";
                } else {
                  return "Declined";
                }
              },
            }}
            actions={false}
          />
          <Row className="mt-5 align-items-center">
            <Col className="d-none d-md-block" md="3" lg="3">
              <span className="text-secondary fs-6">{totalOrders} result(s)</span>
            </Col>
            <Col xs="12" md="6" lg="6">
              <PaginationBar currentPage={currentPage} noOfPages={noOfPages} changePage={changePage} />
            </Col>
            <Col className="d-md-none d-flex align-items-center mt-3" xs="6" lg="3">
              <span className="text-secondary fs-6">{totalOrders} result(s)</span>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default SellerOrders;
